import React, { forwardRef, useEffect, useState, useContext } from 'react';

import DataPlaceholder from './DataPlaceholder';
import uniqueId from '../../utils/uniqueId';
import { UserStateContext } from '../Context';
import { FormContext } from '../Context';

import './LabeledSelect.scss';
import { t } from 'i18next';

const LabeledSelect = forwardRef((props, ref) => {
    const { triggerValidation, validationFinished } = useContext(FormContext);
    let { value, setValue, labelText, placeholder, disabled, autofocus, onChange, required } = props;
    const { doingAjax } = React.useContext(UserStateContext);
    const [myId] = React.useState(uniqueId());
    const [currentValue, setCurrentValue] = React.useState(value);
    const [interacted, setInteracted] = useState(false);
    const [isRequired, setIsRequired] = useState(typeof required === 'boolean' ? required : false);
    const [isValid, setIsValid] = useState(isRequired && interacted && currentValue === -1 ? false : true);
    if (typeof disabled === 'undefined') disabled = false;

    const permanentDisable = disabled === true;

    const descriptionElement = props.description ? (
        <div id={'describes-' + myId}>
            {props.description}
            <br />
        </div>
    ) : null;

    const labeledSelectOnChange = (event) => {
        setInteracted(true);
        if (typeof setValue === 'function') return setValue(event.target.value);
        else if (typeof onChange === 'function') onChange(event);

        setCurrentValue(event.target.value);
        if (isRequired) parseInt(event.target.value) !== -1 && event.target.value !== '' ? setIsValid(true) : setIsValid(false);
    };

    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    useEffect(() => {
        setIsRequired((prev) => (typeof required === 'boolean' ? required : prev));
    }, [required]);

    useEffect(() => {
        if (isRequired && triggerValidation) {
            setInteracted(true);
            parseInt(currentValue) === -1 ? setIsValid(false) : setIsValid(true);
            validationFinished(true);
        }
    }, [currentValue, isRequired, triggerValidation, validationFinished]);

    return (
        <div className={(props.className ? props.className + ' ' : '') + 'labeled-select ' + (!isValid ? 'invalid' : '')}>
            <label htmlFor={'labeled-select-' + myId}>
                {isRequired ? <span className="is-required">&#8270;</span> : null} {labelText}
                <br />
                {descriptionElement}
                {props.showDataPlaceholder ? (
                    <DataPlaceholder />
                ) : (
                    <select
                        id={'labeled-select-' + myId}
                        ref={ref}
                        disabled={permanentDisable ? true : doingAjax}
                        placeholder={placeholder}
                        value={currentValue}
                        onChange={labeledSelectOnChange}
                        autoFocus={autofocus}
                        aria-describedby={descriptionElement ? 'describes-' + myId : null}
                        aria-invalid={!isValid}
                        data-form-key={!!props.formKey ? props.formKey : null}
                        aria-required={isRequired ? 'true' : 'false'}
                    >
                        {props.children ? props.children : null}
                    </select>
                )}
            </label>
            <span
                className="invalid-reason"
                id={'input_err-' + myId}
            >
                {t('LabeledSelect.InvalidMessage')}
            </span>
        </div>
    );
});

LabeledSelect.displayName = 'LabeledSelect';

export default LabeledSelect;
